import { render } from "./CartPanel.vue?vue&type=template&id=b4bc469a&scoped=true"
import script from "./CartPanel.vue?vue&type=script&lang=js"
export * from "./CartPanel.vue?vue&type=script&lang=js"

import "./CartPanel.vue?vue&type=style&index=0&id=b4bc469a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bc469a"]])

export default __exports__